<!-- table-generic.component.html -->
<div class="table-container" [class.loading]="loading">
  <!-- Título y Filtro -->
  <div class="table-header" *ngIf="config.title">
    <h2>{{ config.title }}</h2>
    <div *ngIf="activarBusqueda" class="filter-input">
      <mat-form-field appearance="outline">
        <mat-label>Buscar</mat-label>
        <input
          #filterInput
          matInput
          [value]="filterValue"
          (input)="applyFilter(filterInput.value)"
          placeholder="Filtrar..."
          autocomplete="off">
      </mat-form-field>
    </div>
  </div>

  <!-- Error -->
  <div class="error-message" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>

  <!-- Tabla -->
  <div class="table-wrapper">
    <table mat-table [dataSource]="displayData" matSort (matSortChange)="onSortChange($event)" [class.sticky]="config.stickyHeader">

      <!-- Columnas dinámicas -->
      <ng-container *ngFor="let column of getVisibleColumns()">
        <ng-container [matColumnDef]="column.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="{{column.sortable ? column.key : ''}}"
              [style.width]="column.width"
              [style.text-align]="column.align || 'left'">
            {{ column.title }}
          </th>
          <td mat-cell *matCellDef="let row" [style.text-align]="column.align || 'left'">
            <ng-container *ngIf="!customTemplates[column.key]; else customTemplate">
              <!-- Mostrar badge si la columna es de tipo badge -->
              <ng-container *ngIf="column.type === 'badge'">
                <mat-chip [class]="getBadgeClass(getCellValue(row, column), column)" class="badge-chip">
                  {{ formatValue(getCellValue(row, column), column) }}
                </mat-chip>
              </ng-container>

              <!-- Mostrar chips si la columna es de tipo chips -->
              <ng-container *ngIf="column.type === 'chips'">
                <div class="chips-container">
                  <mat-chip *ngFor="let chip of getChipValues(getCellValue(row, column))" class="tag-chip">
                    {{ chip }}
                  </mat-chip>
                  <span *ngIf="!getChipValues(getCellValue(row, column))?.length" class="no-chips">-</span>
                </div>
              </ng-container>

              <!-- Mostrar acciones si la columna es de tipo actions -->
              <ng-container *ngIf="column.type === 'actions'">
                <div class="actions-container">
                  <button mat-icon-button *ngFor="let action of column.actions"
                          [matTooltip]="action.tooltip"
                          [color]="action.color || 'primary'"
                          (click)="onActionClick(row, action); $event.stopPropagation()">
                    <mat-icon>{{action.icon}}</mat-icon>
                  </button>
                </div>
              </ng-container>

              <!-- Mostrar valor normal para otros tipos -->
              <ng-container *ngIf="!['badge', 'actions', 'chips'].includes(column.type || 'text')">
                {{ formatValue(getCellValue(row, column), column) }}
              </ng-container>
            </ng-container>
            <ng-template #customTemplate>
              <ng-container *ngTemplateOutlet="customTemplates[column.key]; context: { $implicit: row }"></ng-container>
            </ng-template>
          </td>
        </ng-container>
      </ng-container>

      <!-- Columna de acciones por defecto (solo si no hay columnas de acciones personalizadas) -->
      <ng-container matColumnDef="actions" *ngIf="displayedColumns.includes('actions') && !hasCustomActions()">
        <th mat-header-cell *matHeaderCellDef style="width: 120px; text-align: right;">Acciones</th>
        <td mat-cell *matCellDef="let row" style="width: 120px; text-align: right;">
          <div class="actions-container">
            <button mat-icon-button *ngIf="canEdit" color="primary" matTooltip="Editar"
                    (click)="onEdit(row); $event.stopPropagation()">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button *ngIf="canDelete" color="warn" matTooltip="Eliminar"
                    (click)="onDelete(row); $event.stopPropagation()">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Encabezado y filas -->
      <tr mat-header-row *matHeaderRowDef="getColumnsToDisplay()"></tr>
      <tr mat-row *matRowDef="let row; columns: getColumnsToDisplay();" [class.expanded]="isExpanded(row)"></tr>
    </table>
  </div>

  <!-- Paginador -->
  <mat-paginator *ngIf="config.pageSizeOptions?.length"
                 [length]="paginatorLength"
                 [pageSize]="pageSize"
                 [pageIndex]="pageIndex"
                 [pageSizeOptions]="config.pageSizeOptions ?? [10, 25, 50, 100]"
                 (page)="onPageChange($event)">
  </mat-paginator>

  <!-- Cargando -->
  <div class="loading-overlay" *ngIf="loading">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
